import React, { Component } from 'react'
import _ from 'lodash'

class CupoInfo extends Component {
  constructor (props) {
    super(props)
    this.defaultFields = [
      'fecha', 'ctg', 'camion', 'cereal', 'exportador',
      'titularDeCupo', 'tipoDecupo', 'corredor'
    ]
    this.renderField = this.renderField.bind(this)
    this.renderFields = this.renderFields.bind(this)
  }

  renderField ({ field, value, key }) {
    return (
      <div key={key}>
        <div className='info-cupo-label'> {_.startCase(field)} </div>
        <div className='info-cupo-value'> {value} </div>
      </div>
    )
  }

  renderFields (cupo, fields = null) {
    fields = fields || this.defaultFields
    return (
      <>
        <div className='info-cupo-row'>
          {fields.filter(field => cupo[field])
            .map((field, key) => this.renderField({ field, value: cupo[field], key }))}
        </div>
      </>
    )
  }

  render () {
    const { cupo, fields } = this.props
    return (
      <>
        <div className='d-flex info-cupo'>
          {this.renderFields(cupo, fields)}
        </div>
      </>
    )
  }
}

export default CupoInfo
